import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UsernameEditor from "./UsernameEditor";
import { useAuth } from "./AuthProvider";
import { supabase } from "../tattoo/lib/supabaseClient";

export default function UsernameSetupPage() {
  const nav = useNavigate();
  const { session } = useAuth();
  const display = session?.user?.user_metadata?.full_name || session?.user?.email || "friend";

  const [done, setDone] = useState(false);
  const [savedUsername, setSavedUsername] = useState("");

  async function goToApp() {
    // Navigate with an optimistic pass; ProtectedRoute also subscribes to realtime updates.
    requestAnimationFrame(() =>
      nav("/app", { replace: true, state: { usernameJustSaved: true } })
    );
  }

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", padding: 24 }}>
      <div style={{ width: 420, maxWidth: "90vw", background: "#161616", borderRadius: 12, padding: 20, border: "1px solid #2a2a2a" }}>
        <h2 style={{ marginTop: 0, color: "#fff" }}>Welcome, {display} 👋</h2>
        <p style={{ color: "#cfcfcf", marginTop: 8 }}>
          Pick a public username to use in comments and collaboration.
        </p>

        <UsernameEditor
          onSuccess={async (maybeUsername) => {
            try { localStorage.removeItem("tt_force_username"); } catch {}
            let uname = (typeof maybeUsername === "string" ? maybeUsername : "").trim();

            if (!uname && session?.user?.id) {
              const { data } = await supabase
                .from("profiles")
                .select("username")
                .eq("id", session.user.id)
                .maybeSingle();
              uname = data?.username?.trim() || "";
            }

            setSavedUsername(uname);
            setDone(true);
          }}
        />

        {done && (
          <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
            <button
              type="button"               // prevent form submit/reload
              className="btn"
              onClick={goToApp}
              style={{ padding: "8px 14px", borderRadius: 8 }}
            >
              {`Hey ${savedUsername || "friend"}, enter the Tattune Parlour →`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}